<form [formGroup]="form" (ngSubmit)="onSubmitForm()">
  <div class="row">
    <div class="col">
      <div class="form-group pt-2 selector-class">
        <label for="fileCompressionBitrate">
          {{ 'Settings::FileCompression:Bitrate' | abpLocalization }}
        </label>
        <ca-select
          [class]="'below-all'"
          formControlName="fileCompressionBitrate"
          id="fileCompressionBitrate">
          <ca-option
            *ngFor="let fileCompressionBitrate of availableFileCompressionBitrates"
            [value]="fileCompressionBitrate.code">
            {{ 'GenericLookup::' + fileCompressionBitrate.code | abpLocalization }}
          </ca-option>
        </ca-select>
      </div>
    </div>
    <div class="col"></div>
    <div class="col"></div>
  </div>
  <div class="row">
    <div class="col">
      <div class="form-group pt-2 selector-class">
        <label for="fileCompressionAudioFormat">
          {{ 'Settings::FileCompression:AudioFormat' | abpLocalization }}
        </label>
        <ca-select
          [class]="'below-all'"
          formControlName="fileCompressionAudioFormat"
          id="fileCompressionAudioFormat">
          <ca-option
            *ngFor="let fileCompressionAudioFormat of fileCompressionAudioFormats"
            [value]="fileCompressionAudioFormat.code">
            {{ 'GenericLookup::' + fileCompressionAudioFormat.code | abpLocalization }}
          </ca-option>
        </ca-select>
      </div>
    </div>
    <div class="col"></div>
    <div class="col"></div>
  </div>
  <div class="row">
    <div class="col pt-2">
      <small class="form-text text-muted">
        {{ 'Settings::FileCompression:Description' | abpLocalization }}
      </small>
    </div>
    <div class="col"></div>
    <div class="col"></div>
  </div>
  <button type="submit" class="btn btn-primary mt-3">
    <i class="me-1 fas fa-save"></i>
    {{ 'AbpUi::Save' | abpLocalization }}
  </button>
</form>
